/*******************************/
// Bỏ các route vào trong này khi không cần phân quyền
// Mục đích dùng để test thôi! Làm xong nhớ bỏ đi
/*******************************/
import React from "react";
//const MapPublic = React.lazy(() => import('../views/MapOL/MapPublic'));

const includes = [
  //{ path: '/map', exact: true, name: 'MapPublic', component: MapPublic },
];

export default includes;
